import {
  contractService,
} from '@/entities/contract/api/contract.api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const contractKeys = {
  all: ['contracts'] as const,
  /** 기준월 별첨 목록 — 레거시 getArtifacts(refYm) */
  appendixList: (refYm: string) =>
    [...contractKeys.all, 'appendix', refYm] as const,
};

/**
 * 계약 별첨 목록 조회.
 * 레거시 `useContractAppendixService.getArtifacts` 대응.
 */
export const useContractAppendixList = (refYm: string) =>
  useQuery({
    queryKey: contractKeys.appendixList(refYm),
    queryFn: () => contractService.getAppendixArtifacts(refYm),
    enabled: Boolean(refYm) && refYm.length === 6,
    retry: false,
  });

export const useGenerateContractAppendix = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      refYm,
      version = 1,
    }: {
      refYm: string;
      version?: number;
    }) => contractService.generateAppendix(refYm, version),
    onSuccess: (_data, { refYm }) => {
      // 화면에서 refetch 1회만 수행 (invalidate 자동 refetch와 중복 방지)
      queryClient.invalidateQueries({
        queryKey: contractKeys.appendixList(refYm),
        refetchType: 'none',
      });
    },
  });
};

export const useContractAppendixDownloadUrl = () =>
  useMutation({
    mutationFn: ({
      refYm,
      version = 1,
    }: {
      refYm: string;
      version?: number;
    }) => contractService.getAppendixDownloadUrl(refYm, version),
  });
